module.exports = __webpack_public_path__ + "assets/img/modal-avatar-7edd4962.png";